module.exports = __webpack_public_path__ + "src/assets/img/5_2art_2part.36398166.jpg";